// note all service ids are lowercase
export const SERVICE_IDS = {
    home: 'home',
    automationhub: 'automationhub',
    automationstore: 'automationstore',
    actions: 'actions',
    apps: 'apps',
    chatbots: 'chatbots',
    entities: 'entities',
    orchestrator: 'orchestrator',
    processes: 'processes',
    insights: 'insights',
    marketplace: 'marketplace',
    testmanager: 'testmanager',
    integrations: 'connections', // Note: this is by design; integrations is using connections as their URL
    dataservice: 'dataservice',
    taskmining: 'taskmining',
    processmining: 'processmining',
    studio: 'studio',
    du: 'du',
    reinfer: 'reinfer',
    roboticsops: 'roboticsops',
    admin: 'admin',
    aifabric: 'aifabric',
    help: 'help',
};

export const defaultServiceOrder = [
    SERVICE_IDS.home,
    SERVICE_IDS.orchestrator,
    SERVICE_IDS.studio,
    SERVICE_IDS.actions,
    SERVICE_IDS.automationhub,
    SERVICE_IDS.apps,
    SERVICE_IDS.chatbots,
    SERVICE_IDS.processes,
    SERVICE_IDS.insights,
    SERVICE_IDS.marketplace,
    SERVICE_IDS.testmanager,
    SERVICE_IDS.integrations,
    SERVICE_IDS.dataservice,
    SERVICE_IDS.taskmining,
    SERVICE_IDS.processmining,
    SERVICE_IDS.aifabric,
    SERVICE_IDS.du,
    SERVICE_IDS.reinfer,
    SERVICE_IDS.roboticsops,
    SERVICE_IDS.admin,
    SERVICE_IDS.automationstore,
    SERVICE_IDS.help,
];
